import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('studentdb');

const studentdbRoutes = [
  {
    path: '/territory-info',
    name: 'territory-info-dashboard',
    meta: {
      showNav: true,
      feature: 'student_db',
    },
    component: loadView('StudentsDashboard'),
  },
  {
    path: '/territory-info/schools/:schoolId',
    name: 'territory-info-school-detail',
    meta: {
      showNav: true,
      feature: 'student_db',
    },
    props: true,
    component: loadView('StudentsSchoolDetail'),
  },
  {
    path: '/territory-info/:state',
    name: 'territory-info-state-detail',
    meta: {
      showNav: true,
      feature: 'student_db',
    },
    props: true,
    component: loadView('StudentsStateDetail'),
  },
];

export default studentdbRoutes;
